(function(){
  var lastRow;

  function clearSelectors(){
    this.set('content', null);
    this.set('controllers.blockOperations.content', null);
  }

  var UP_DIRECTION = -1,
      DOWN_DIRECTION = 1;

  function moveRow(direction, currentIndex){
    var context = PegasusTemplate.blockRegionInstance.objectAt(currentIndex),
      prospect,
      actorIndex,
      originalActor = prospect = actor = context;

    // noop situations
    switch(direction){
      case UP_DIRECTION:
        if ( currentIndex == 0 ){
          clearSelectors.call(this);
          return;
        }
        break;
      case DOWN_DIRECTION:
        if ( currentIndex === PegasusTemplate.blockRegionInstance.get('length') - 1 ){
          clearSelectors.call(this);
          return;
        }
        break;
    }

    var callback = clearSelectors;

    var cookie;
    cookie = actor.mutateForOut(null, true).editor_cookie;

    var command = PegasusTemplate.MoveRowCommand.create({
      klass: actor.constructor,
      backup: cookie,
      sourceElement: cookie,
      callback: callback.bind(this),
      childPosition: PegasusTemplate.blockRegionInstance.indexOf( actor ),
      desiredPosition: currentIndex + direction
    });

    command.execute();
  }

  PegasusTemplate.RowOperationsController = Em.ObjectController.extend({
    needs: ['blockOperations', 'toolbar', 'columnOperations', 'viewOptions'],
    showColorPicker: false,

    zoomValue: function(){
      return this.get('controllers.viewOptions.zoomValue');
    }.property('controllers.viewOptions.zoomValue'),

    saveChange: function(){
      function commandChange(){
        var command = PegasusTemplate.EditRowColorCommand.create({
          klass: this.get('content').constructor,
          backup: this.get('sourceElement'),
          sourceElement: this.get('content').mutateForOut(null, true).editor_cookie.replace(/data-background-image=\".*?\"/g, 'data-background-image=""'),
          childPosition: PegasusTemplate.blockRegionInstance.indexOf( this.get('content') ),
          executeColor: this.get('dataRowColor')
        });

        command.execute();
      }

      commandChange.call(this);
    },

    setBackground: function(color){
      var index = PegasusTemplate.blockRegionInstance.indexOf( this.get('content') ),
        executeChange = function(){
          var cookie = PegasusTemplate.blockRegionInstance.objectAt(index).get('sourceElement'),
            command = PegasusTemplate.EditBlockCommand.create({
              klass: this.get('controller.content').constructor,
              backup: cookie,
              childPosition: index,
              callback: function(){
                this.set('content', null);
              }.bind(this)
            });

          PegasusTemplate.blockRegionInstance.objectAt(index).set('dataRowColor', color);

          Em.run.scheduleOnce('afterRender', this, function(){
            command.set('sourceElement', PegasusTemplate.blockRegionInstance.objectAt(index).mutateForOut(null, true).editor_cookie);
            command.execute();
            PegasusTemplate.stateMachine.transitionTo('idling');
          });
        }.bind(this);

      var actor = this.get('content');
      var isEdited =
        actor.get('isEdited');

      if ( isEdited ) {
        PegasusTemplate.Helpers.addOneTimeObserver(PegasusTemplate.stateMachine, 'currentPath', 'saved', function(){
          Em.run.scheduleOnce('afterRender', this, executeChange);
        }.bind(this));
        PegasusTemplate.stateMachine.send('didSave');
        return;
      }

      executeChange();
    },

    // show the row menu when the row is clicked
    // and we aren't editing
    editContentBackground: function(){
      var isEdited =
        this.get('isEdited');

      if ( this.get('content') && ! isEdited ) {
        $('.row-spectrum-button').click();
      }
    },

    toggleLock: function(){
      if (this.get('content.dataRowLocked') === 'true') {
        this.set('content.dataRowLocked', 'false');
      } else {
        this.set('content.dataRowLocked', 'true');
      }
    },

    init: function(){
      var self = this;

      this._super();
      $(window).on('resize.row-controller', function(e){
        Em.run(self, function(){
          // inspect with breakpoint not debugger in here
          this.set('content', null);
        });
      });
    },

    destroy: function(){
      $(window).off('resize.row-controller');
      this._super();
    },

    content: function(_, value) {
      var blockOpsContent = this.get('controllers.blockOperations.content'),
        row;

      if ( typeof( value) !== 'undefined' ) {
        lastRow = value;
        return lastRow;
      }

      row = blockOpsContent ? blockOpsContent.get('row') : lastRow;

      if ( row ) {
        lastRow = row;
      }

      return lastRow;
    }.property('controllers.blockOperations.content'),
    moveRowUp: function(count, rowIndex){
      Em.run.scheduleOnce('afterRender', this, moveRow, -1*count, rowIndex);
    },
    moveRowDown: function(count, rowIndex){
      Em.run.scheduleOnce('afterRender', this, moveRow, +1*count, rowIndex);
    },
    mirrorRow: function() {
      var row = this.get('content');

      $(window).off('click.' + 'mirrow-classes').one('click.' + 'mirrow-classes', function(){
        $('.popped-row').removeClass('popped-row');
        $('.selected-mirror-column').removeClass('selected-mirror-column');
      });

      //if ( row.get('mirrorCapable').length ) {
        Em.run.scheduleOnce('afterRender', null, function(){
          $('body').addClass('popped-row');
        });
      //}
    },
    deleteRow: function(klass, cookie, originalSource, index){
      var ourClass = klass,
        newValue = cookie,
        childPosition = index,
        originalValue = originalSource,
        deleteParams = {
          klass: ourClass,
          backup: newValue,
          callback: function(){
            this.set('content', null);
          }.bind(this),
          childPosition: childPosition
        },
        saveParams = {
          klass: ourClass,
          sourceElement: newValue,
          backup: originalValue,
          childPosition: childPosition
        },
        doDelete = function(){
          var deleteCommand = PegasusTemplate.DeleteRowCommand.create(deleteParams);
          deleteCommand.execute();
        };

      // for convenience we create a snapshot right before they
      // deleted it
      //if (  this.get('isEdited') ||
           //this.get('backgroundImageCell.isEdited') ) {
          //var saveCommand = PegasusTemplate.EditBlockCommand.create(saveParams);
          //saveCommand.execute();
          //PegasusTemplate.stateMachine.transitionTo('idling');

          Em.run.scheduleOnce('afterRender', this, doDelete);

      //} else {
        //doDelete();
      //}
    },
    copyRow: function(klass, cookie, index){
      var element = $(cookie);

      element.find('*').removeAttr('id');
      element.removeAttr('id');

      var source = element[0].outerHTML;

      var command = PegasusTemplate.CopyRowCommand.create({
        klass: klass,
        sourceElement: source,
        desiredPosition: index
      });

      command.execute();
    },
    rotateRow: function(){
      var cookie = this.get('content').mutateForOut(null, true).editor_cookie,
        command = PegasusTemplate.RotateRowCommand.create({
          klass: this.get('content').constructor,
          backup: cookie,
          childPosition: PegasusTemplate.blockRegionInstance.indexOf( this.get('content') )
        });

      command.execute();
    },
    addPadding: function(){
      var oldVal = this.get('content.topPaddingCell.dataVrStructurePaddingTop'),
        newVal = +(oldVal) + 5;

      newVal = newVal > 0 ? newVal : 0;

      this.get('topPaddingCell').set('dataVrStructurePaddingTop', newVal);
    },
    reducePadding: function(){
      var oldVal = this.get('content.topPaddingCell.dataVrStructurePaddingTop'),
        newVal = +(oldVal) - 5;

      newVal = newVal > 0 ? newVal : 0;

      this.get('topPaddingCell').set('dataVrStructurePaddingTop', newVal);
    },
    addBottomPadding: function(){
      var oldVal = this.get('bottomPaddingCell.dataVrStructurePaddingBottom'),
        newVal = +(oldVal) - 5;

      newVal = newVal > 0 ? newVal : 0;

      this.get('bottomPaddingCell').set('dataVrStructurePaddingBottom', newVal);
    },
    reduceBottomPadding: function(){
      var oldVal = this.get('bottomPaddingCell.dataVrStructurePaddingBottom'),
        newVal = +(oldVal) + 5;

      newVal = newVal > 0 ? newVal : 0;

      this.get('bottomPaddingCell').set('dataVrStructurePaddingBottom', newVal);
    }
  });
})();
